/**
 * @copyright WaterStreet. All rights reserved.
 */

/**
 * A constant library used to defined names used in the system service
 * settings.
 *
 * @export
 * @const SystemServiceConstants
 */
export const SystemServiceConstants:
{
	chat: string;
	chatData: string;
	componentName: string;
	deploymentId: string;
	enabled: string;
	environment: string;
	knowledgeBaseComponent: string;
	knowledgeBaseEnabled: string;
	knowledgeBaseUrl: string;
	modalService: string;
	offline: string;
	offlineMessage: string;
	stonly: string;
	systemName: string;
	widgetId: string;
} =
	{
		chat: 'chat',
		chatData: 'chatData',
		componentName: 'componentName',
		deploymentId: 'deploymentId',
		enabled: 'enabled',
		environment: 'environment',
		knowledgeBaseComponent: 'knowledgeBaseComponent',
		knowledgeBaseEnabled: 'knowledgeBaseEnabled',
		knowledgeBaseUrl: 'knowledgeBaseUrl',
		modalService: 'modalService',
		offline: 'offline',
		offlineMessage: 'offlineMessage',
		stonly: 'stonly',
		systemName: 'systemName',
		widgetId: 'widgetId'
	};